<template>
	<div>

		<!-- <div>
			<table-filter :filters="filters" @onFilter="onFilterBackend" @onClear="clearFilters"></table-filter>
		</div> -->
		<FiltersTable titleButton="Obtener órdenes" searchPlaceholder="Buscar por 'Órden ML'" @onSearch="onSearch"/>


		<VxTable 
			stripe 
			:data="orders" 
			pagination 
			:max-items="30"
			:total="totalItems"
			:sst="true" 
			@change-page="handleChangePage" >
			
			<template slot="thead">
				<vs-th>Órden ML</vs-th>
				<!-- <vs-th>Destinatario</vs-th> -->
				<vs-th>Comprador</vs-th>
				<vs-th v-if="mode === 'flex'">Producto</vs-th>
				<vs-th>Valor</vs-th>
				<vs-th v-if="mode === 'flex'">Destino</vs-th>
				<vs-th v-if="mode === 'flex'">Motivo</vs-th>
				<vs-th>Fecha</vs-th>
				<!-- "Actualizada" y "Modo" salen del panel Flex: la solapa ya filtra por Flex, y esos dos lugares se usan para Producto y Destino. -->
				<vs-th v-if="mode !== 'flex'">Actualizada</vs-th>
				<vs-th v-if="mode !== 'flex'">Modo</vs-th>
				<vs-th>Acciones</vs-th>
			</template>

			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" >
					<vs-td>
						{{ data[indextr].id }}
						<br v-if="data[indextr].pack_id" />
						<small v-if="data[indextr].pack_id" class="order-pack-id">N° compra: {{ data[indextr].pack_id }}</small>
					</vs-td>
					<vs-td>
						Cuenta: <em>{{tr.buyer.first_name}} {{tr.buyer.last_name}} ({{tr.buyer.nickname}}).</em> <br>
						<template v-if="tr.shipment_data && tr.shipment_data.receiver_address">
							Recibe:  <em>{{tr.shipment_data.receiver_address.receiver_name}} </em>
						</template>
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ productSummary(tr) }}
					</vs-td>
					<vs-td>
						$ {{tr.total_amount}}
					</vs-td>
					<vs-td v-if="mode === 'flex'">
						{{ destinationLabel(tr) }}
					</vs-td>
					<!-- El motivo estaba comentado, asi que el operador no sabia por que la orden era invalida (§8.3). -->
					<vs-td v-if="mode === 'flex'">
						{{ tr.reason_invalid || tr.flex_error || "—" }}
					</vs-td>
					<vs-td>
						{{ data[indextr].date_created | formatDate }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ data[indextr].last_updated | formatDateFromNow }}
					</vs-td>
					<vs-td v-if="mode !== 'flex'">
						{{ orderModeLabel(tr) }}
					</vs-td>
					<vs-td>
						<!-- <vs-button type="border" size="small" color="primary" class="mr-2" 
							@click="openPopupDetalle(data[indextr])">
							<feather-icon icon="SearchIcon" svgClasses="h-2 w-2"/>
							Detalle
						</vs-button> -->
						<feather-icon class="order-action" @click="openDetails(tr)" title="Ver el detalle" icon="EyeIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer" />
						<!-- Es el MISMO POST flex-create-shipment: el backend acepta ordenes en `invalida`, re-valida y limpia el reason_invalid. -->
						<feather-icon class="order-action" v-if="canRetry(tr)" @click="confirmRetry(tr)" title="Reintentar el despacho" icon="RefreshCwIcon" svgClasses="h-5 w-5 mx-1 cursor-pointer text-primary" />
					</vs-td>
				</vs-tr>
			</template>

		</VxTable>

		<div v-if="showDetailModal">
        	<OrderDetails :orderDetail="orderDetail" @orderDetail="handleOrderDetails"/>
    	</div>

	</div>
</template>

<script>
// Extraer: 
// MOMENTJS and CONFIG
// AXIOS and CONFIG
// FILTERS 
import _ from 'lodash'// ya esta improtado en archivo local pero si no lo improto aca da errores aveces

import moment from 'moment'
import { orderModeLabel, productSummary, destinationLabel } from "../../utils/orderLabels";
import { createFlexShipment } from "../../services/meliFlex.service";
import { showConfirmation, showError, showSuccess } from "../../services/alert.service";
import { errorMessage } from "../../http";
moment.locale('es')

import axios from 'axios';
axios.defaults.withCredentials = true;

import OrderDetails from "../../components/modals/Orders/OrderDetails.vue";
import FiltersTable from "../../components/filters-table/FiltersTable.vue";


export default {
	components: {
		OrderDetails,
		FiltersTable
	},
	props: {
		// ME1 o Flex — lo inyectan las rutas (ver router.js); default ME1.
		mode: { type: String, default: 'me1' }
	},
	data(){
		return {
			orders: [],
			ordersPreserved:[], // used when reseting local filtering
			totalItems: 0,
			page: 1,
			selected: [], // Los items seleccionados con el checkbox 
			
			// Popup (detalle & proccesar)
			popupOrder: {}, // El item en que se ha clickeado Detalle o Procesar
			popupOrderShipmentInfo: null,
			// Popup - detalle
			popupDetalleActive: false,
			filtersSelected: [],

			showDetailModal: false,
      orderDetail: {},
		}
	},
	filters : {
		formatDate(rawDate){
			return moment(rawDate).format("D-M-Y");
		},
		formatDateFromNow(rawDate){
			return moment(rawDate).fromNow();
		},
	},


	watch: {
		// Las rutas ME1 y Flex montan ESTE MISMO componente: Vue reutiliza la instancia y no vuelve a ejecutar mounted().
		mode() {
			this.page = 1;
			this.orders = [];
			this.ordersPreserved = [];
			this.totalItems = 0;
			this.selected = [];
			this.loadOrders(1);
		}
	},
	mounted() {
		this.loadOrders();	
	},

	methods: {
		orderModeLabel,
		// Se exponen porque el template los usa: un import de modulo no es visible ahi.
		productSummary,
		destinationLabel,

		// Solo se ofrece reintentar donde la causa puede haberse resuelto. `ORDER_CANCELLED` no se recupera nunca.
		canRetry(tr) {
			if (this.mode !== 'flex' || !tr) return false;
			return tr.flex_error_code === 'MISSING_DIMENSIONS' || tr.flex_error_code === 'CDS_ERROR';
		},

		async confirmRetry(tr) {
			const { isConfirmed } = await showConfirmation({
				title: 'Reintentar el despacho',
				text: `Se volverá a intentar el envío de la orden #${tr.id}. Si sale bien, la orden pasa a Procesadas.`,
				textConfirmButton: 'Sí, reintentar',
				popupClass: 'swal-popup-auto'
			});
			if (!isConfirmed) return;

			this.$vs.loading();

			let respuesta = null;
			let fallo = null;

			// Solo el pedido va dentro del try: el loader se cierra ANTES de cualquier modal que espere un click.
			try {
				const { data } = await createFlexShipment(tr.id);
				respuesta = data;
			} catch (e) {
				fallo = e;
			} finally {
				this.$vs.loading.close();
			}

			if (fallo) {
				const status = fallo.response && fallo.response.status;
				if (status && status !== 401 && status !== 419) {
					showError({ message: errorMessage(fallo, 'No se pudo crear el envío.') });
				}
			} else if (respuesta && respuesta.success === false) {
				showError({ message: respuesta.message || 'No se pudo crear el envío.' });
			} else {
				showSuccess({ message: 'Envío creado. La orden pasó a Procesadas.' });
			}

			// Se recarga pase lo que pase: si salio bien la orden ya no esta en esta solapa.
			this.loadOrders(this.filtersSelected.page || 1);
		},

		loadOrders(page = 1) {
			this.$vs.loading();

			this.filtersSelected['page'] = page;
			this.filtersSelected['mode'] = this.mode;

			try {
				const filtersSelected = this.filtersSelected;
				const query = Object.keys(filtersSelected)
				.map(key => encodeURIComponent(key) + '=' + encodeURIComponent(filtersSelected[key]))
				.join('&');

				axios.get(process.env.VUE_APP_BACKEND_URL + 'api/orders-invalid?' + query)
				.then(orders => {

					const body = orders.data.body || [];
					const paging = orders.data.paging || {};

					// Si `body` no viniera, antes la grilla se quedaba con las filas anteriores.
					this.orders = body;
					this.ordersPreserved = body;

					// `total` puede ser 0 en una busqueda sin resultados: con un `if` el paginador seguia en la consulta previa.
					this.totalItems = paging.total || 0;
				})
				.catch(e => {
					console.log(e);
				})
				.finally(() => {
					this.$vs.loading.close();
				});

			} catch (e) {
				console.log(e);
				this.$vs.loading.close(); 
			}
		},

		handleChangePage (page) {
			this.page = page
			this.loadOrders(page)
		},

		onSearch(value) {
			this.filtersSelected = value;
			this.loadOrders(1);
		},

		// NEW METHODS FOR ACTIONS
		openDetails(tr) {
		this.orderDetail = tr;
		this.showDetailModal = true;
	},
	handleOrderDetails() {
		this.orderDetail = null;
		this.showDetailModal = false;
		},
	}
}
</script>